import EthnicityReportContainer from './ethnicity_report_container';

const EthnicityReport = EthnicityReportContainer;
export default EthnicityReport;
